import { isValid } from "../utilitiesmodule";

export const TICKET_STATUS = {
	PENDING: 0, ASSIGNED: 1, IN_SESSION: 2, COMPLETED: 3, RELEASED: 4, CANCELLED: 5
}

export const TICKET_STATUS_INFO = {
	0: {
		value: 0,
		label: "Pending",
		bgcolor: "red",
		color: "white",
		nextStatusValues: [TICKET_STATUS.ASSIGNED, TICKET_STATUS.CANCELLED],
		isQuick: true,
		badge_style: "background-color: #fef2f2;border-color: #fecaca;color: #dc2626;"

	},
	1: {
		value: 1,
		label: "Assigned",
		bgcolor: "blue",
		color: "white",
		nextStatusValues: [TICKET_STATUS.IN_SESSION, TICKET_STATUS.COMPLETED, TICKET_STATUS.RELEASED, TICKET_STATUS.CANCELLED],
		isQuick: false,
		badge_style: "background-color: #eff6ff;border-color: #bfdbfe;color: #2563eb;"

	},
	2: {
		value: 2,
		label: "In session",
		bgcolor: "blue",
		color: "white",
		nextStatusValues: [TICKET_STATUS.COMPLETED, TICKET_STATUS.RELEASED, TICKET_STATUS.CANCELLED],
		isQuick: true,
		badge_style: "background-color: #eff6ff;border-color: #bfdbfe;color: #2563eb;"

	},
	3: {
		value: 3,
		label: "Completed",
		bgcolor: "green",
		color: "white",
		nextStatusValues: [],
		isQuick: true,
		badge_style: "background-color: #f0fdf4;border-color: #bbf7d0;color: #16a34a;"
	},
	4: {
		value: 4,
		label: "Released",
		bgcolor: "red",
		color: "white",
		nextStatusValues: [TICKET_STATUS.ASSIGNED, TICKET_STATUS.CANCELLED],
		isQuick: true,
		badge_style: "background-color: #fffbeb; border-color: #fde68a; color: #d97706;"


	},
	5: {
		value: 5,
		label: "Cancelled",
		bgcolor: "red",
		color: "white",
		nextStatusValues: [],
		isQuick: true,
		badge_style: "background-color: #fef2f2;border-color: #fecaca;color: #dc2626;"

	}
}

export const TICKET_PRIORITY = {
	NOT_SET: 0, URGENT: 1, HIGH: 2, MEDIUM: 3, LOW: 4
}

export const TICKET_PRIORITY_INFO = {
	0: {
		value: 0,
		label: "Not set",
		bgcolor: "white",
		color: "black",
		badge_style: "background-color: #f8fafc; border-color: #e2e8f0; color: #475569;"
	},
	1: {
		value: 1,
		label: "Urgent",
		badge_style: "background-color: #fef2f2;border-color: #fecaca;color: #dc2626;"
	},
	2: {
		value: 2, label: "High", bgcolor: "red", color: "white",
		badge_style: "{ background-color: #fff7ed; border-color: #fed7aa; color: #ea580c;"
	},
	3: {
		value: 3, label: "Medium", bgcolor: "yellow", color: "black",
		badge_style: "background-color: #fffbeb; border-color: #fde68a; color: #d97706;"
	},
	4: {
		value: 4, label: "Low", bgcolor: "green", color: "white",
		badge_style: "background-color: #f0fdf4;border-color: #bbf7d0;color: #16a34a;"
	}
}

export async function populateUsefulMaps() {
	await this.$root.ensureUsefulMaps();

	const allTeams = Object.values(this.$root.teamMap);
	this.$root.userLoggedIsLeadOfSomeTeam = allTeams.some(team =>
		(team.users || []).some(user => user.is_lead && user.id_user == this.$root.authObj.id_user)
	);
}

